<template>
  <div class="container" :key="fullCode">
    <fullPage @leaveSlide="leaveSlide" :currentParent="fullIndex" ref="fullPage">
      <div slot="section" class="container">
        <periphery-first :currentIndex="currentIndex"></periphery-first>
      </div>
      <div slot="section" class="container">
        <periphery-second :currentIndex="currentIndex"
                          @scrollListener="scrollListener"></periphery-second>
      </div>
    </fullpage>
  </div>
</template>

<script>
  import peripheryFirst from '@/page/periphery/components/PeripheryFirst'
  import peripherySecond from '@/page/periphery/components/PeripherySecond'
  import fullPage from '@/components/fullPage'
  import merge from 'webpack-merge'
    export default {
        name: "Periphery",
      data() {
        return {
          fullIndex: 0,
          fullCode: 0,
          currentIndex: 1,
          lastIndex: 2,
        }
      },

      components: {
        peripheryFirst,
        peripherySecond,
        fullPage,
      },

      mounted() {
        if (!this.$store.state.isPc) {
          this.$store.commit('isAlphaEdit', true)
        }
        this.fullIndex = parseInt(this.$route.query.index)
      },

      watch: {
        '$route': function (newUrl, oldUrl) {
          if (newUrl != oldUrl && this.$store.state.isSlide) {
            this.fullCode = parseInt(this.$route.query.index)
            this.fullIndex = parseInt(this.$route.query.index)
          }
        }
      },

      methods: {
        leaveSlide(item) {
          this.currentIndex = item.currentIndex
          this.lastIndex = item.currentIndex
          this.$router.push({
            query:merge(this.$route.query,{index:item.currentIndex})
          })
          this.$store.commit('slideEdit',false)
          this.$store.commit('edit',item.currentIndex - 1)
          if ( item.currentIndex == 2) {
            this.$refs.fullPage.api.setAllowScrolling(false)
          }
        },
        scrollListener(e) {
          this.$refs.fullPage.api.setAllowScrolling(true)
        },
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/periphery/Periphery.vue